import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "../reducers/commonState";

const store = configureStore({
  reducer: {
    common: commonReducer,
  },
});

export default store;
